import BaseListPresenter from "../../../base/BaseListPresenter";
import { dialog } from "../../../nq-component";
import { liveQueryUseCase } from "../../../usecases/livequery";
import { findObjectUseCase } from "../../../usecases/object";

class QueueingViewPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;

    this.audio = new Audio("/ding.mp3");
  }

  init() {
    this.limit = {};
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["recruiter", "recruiter.employee"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  componentDidMount() {
    this.init();
    this.findRecruiter();
    // this.subscribe();
    this.startPolling();
    this.getSpeechConfig();
    return this.getObjects();
  }

  async getObjects() {
    this.reset();
    await this.countObjects();
    await this.findObjects();
  }

  // subscribe() {
  //   const query = {
  //     collection: "queue",
  //     where: {},
  //   };

  //   const insertSubscription = liveQueryUseCase().execute(query, "afterInsert");
  //   insertSubscription.on("create", (newProduct) => {
  //     console.warn("COUNTsss", newProduct);
  //     console.count("COUNT", newProduct);
  //     this.objects?.unshift(newProduct);
  //     console.log("real one", this.objects);

  //     this.view.setObjects(this.objects);
  //   });

  //   const updateSubscription = liveQueryUseCase().execute(query, "afterUpdate");
  //   updateSubscription.on("update", (updatedProduct) => {
  //     const index = this.objects?.findIndex(
  //       (obj) => obj.id === updatedProduct.id
  //     );
  //     if (index !== -1) {
  //       this.objects[index] = updatedProduct;

  //       this.audio.play().catch((err) => {
  //         console.warn("Audio play blocked by browser or failed:", err);
  //       });

  //       this.view.setObjects(this.objects);
  //     }
  //   });

  //   const deleteSubscription = liveQueryUseCase().execute(query, "afterDelete");
  //   deleteSubscription.on("delete", (deletedProduct) => {
  //     this.objects = this.objects.filter((obj) => obj.id !== deletedProduct.id);
  //     this.view.setObjects(this.objects);
  //   });

  //   [insertSubscription, updateSubscription, deleteSubscription].forEach(
  //     (subscription) => {
  //       subscription.on("error", (error) => {
  //         console.error("Subscription error:", error);
  //       });
  //     }
  //   );
  // }

  startPolling() {
    this.pollingInterval = setInterval(() => {
      this.pollObjects();
    }, 3000);
  }

  stopPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
  }

  async pollObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();

    try {
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);

      this.objects = objects;
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);
    } catch (error) {
      console.error("Polling error:", error);
    }
  }

  detectChanges(previousObjects, currentObjects) {
    if (previousObjects.length !== currentObjects.length) {
      return true;
    }

    for (let i = 0; i < currentObjects.length; i++) {
      const current = currentObjects[i];
      const previous = previousObjects.find((obj) => obj.id === current.id);

      if (!previous) {
        return true;
      }

      if (JSON.stringify(previous) !== JSON.stringify(current)) {
        return true;
      }
    }

    return false;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const collection2 = "queueServing";
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  async findRecruiter() {
    const collection = "users";

    const query = {
      where: {
        roles: {
          id: "Recruiter",
        },
      },
      include: ["all"],
    };
    try {
      this.showProgress();
      const objects = await findObjectUseCase().execute(collection, query);
      this.view.setRecruiter(objects);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  onClickAdd() {
    const collection = this.view.getCollectionName();
    this.view.navigateTo("/admin/employee/form");
  }

  onClickEdit(empDetails) {
    this.view.navigateTo(`/admin/employees/form/${empDetails?.id}`);
  }

  async onClickUpdateStatus(empDetails) {
    const object = empDetails;
    const collection = this.view.getCollectionName();

    object.status =
      object?.status === "InActive"
        ? "Active"
        : empDetails.status === "Active"
          ? "InActive"
          : null;

    await this.upsertUseCase.execute(collection, object);
    this.view.setObjects(this.objects);
    this.reset();
    this.getObjects();
  }

  async handleSubmit(formData, employee, coordinator) {
    const collection = "request";
    const status = "Pending";
    const data = { ...formData, employee, coordinator, status };

    data.attachmentArray = formData.attachment;

    delete data.attachment;

    const response = await this.upsertUseCase.execute(collection, data);

    if (response) {
      dialog.close();
      this.view.successModal();
    }
  }

  async getSpeechConfig() {
    const collection = "speech_config";

    try {
      const configObject = await this.findObjectUseCase.execute(collection, {
        sort: { created: -1 },
      });
      if (!configObject || configObject.length === 0) {
        return;
      }

      const setting = configObject[0];
      const waitForVoices = (timeoutMs = 2500) =>
        new Promise((resolve) => {
          if (!("speechSynthesis" in window)) {
            resolve([]);
            return;
          }

          let voices = window.speechSynthesis.getVoices() || [];
          if (voices.length > 0) {
            resolve(voices);
            return;
          }

          let done = false;
          let timeoutId = null;

          const handler = () => {
            voices = window.speechSynthesis.getVoices() || [];
            if (voices.length > 0 && !done) {
              done = true;
              window.speechSynthesis.removeEventListener(
                "voiceschanged",
                handler,
              );
              if (timeoutId) clearTimeout(timeoutId);
              resolve(voices);
            }
          };

          window.speechSynthesis.addEventListener("voiceschanged", handler);

          timeoutId = setTimeout(() => {
            if (done) return;
            done = true;
            window.speechSynthesis.removeEventListener(
              "voiceschanged",
              handler,
            );
            voices = window.speechSynthesis.getVoices() || [];
            resolve(voices);
          }, timeoutMs);
        });

      const voices = await waitForVoices();
      let selectedVoice;

      const storedVoiceNameOrObject = setting?.voice_name;
      if (voices.length > 0) {
        if (!storedVoiceNameOrObject) {
          selectedVoice = voices.find((v) => v.default) || voices[0];
        } else if (typeof storedVoiceNameOrObject === "string") {
          selectedVoice =
            voices.find(
              (v) => v.name && v.name.includes(storedVoiceNameOrObject),
            ) ||
            voices.find((v) => v.default) ||
            voices[0];
        } else if (storedVoiceNameOrObject?.name) {
          selectedVoice =
            voices.find((v) => v.name === storedVoiceNameOrObject.name) ||
            storedVoiceNameOrObject;
        } else {
          selectedVoice = voices.find((v) => v.default) || voices[0];
        }
      } else {
        selectedVoice = undefined;
      }

      this.view.setConfig({
        ...setting,
        voice_name: selectedVoice,
      });
    } catch (error) {
      this.view.showError(error);
    }
  }
}

export default QueueingViewPresenter;
